<template>
  <section class="team-content">
    <div class="left">
      <div class="first">
        <div class="teamBig">
          <form id="logo_upload" action="/api/upload_logo" method="POST" enctype="multipart/form-data" ref="imgForm">
            <div class="logo_box">
              <img id="logo" style="display:inline-block; border: 1px solid #eee; width: 190px; height: 190px;" :src="logoUrl" alt="" />
              <input v-if="permission_upload_logo" type="file" name="logo" @change="submit"/>
            </div>
          </form>
        </div>
        <div class="teamDetail">
          <div class="info">
            <div class="name">
              <span>{{teamName}}</span>
            </div>
            <div class="status">
              {{rank_}}:&nbsp;
              <span>{{rank}}/{{total_teams}}</span>
              &nbsp;&nbsp;{{score_}}:&nbsp;
              <span>{{score}}</span>
              <br />
              <span v-if="ctfMode == 'teams'">
                  {{teamMembers_}}:&nbsp;
                  <span>{{size}}</span>
                  <!--&nbsp;{{location_}}: <img :title="flagTitle" :src="flagURL"></img>-->
              </span>
            </div>
          </div>
          <div class="operation" v-if="profile.token">
            <div>{{teamToken_}}: <span class="token">{{profile.token}}</span></div>
            <div v-if="permission_upload_logo">{{clickToUpload_}}</div>
          </div>
        </div>
      </div>
      <!--first ends and second start-->
      <div class="second">
        <span>{{solvedChallenges_}}:<i class="number">{{solved}}</i><i>{{solved_}}</i><i class="sep">/</i><i class="number">{{total_problems}}</i><i>{{total_}}</i></span>
        <ul class="table">
          <li class="thead">
            <a>
              <span>{{name_}}</span>
              <span>{{score_}}</span>
              <span>{{solvedBy_}}</span>
              <span>{{time_}}</span>
            </a>
          </li>
          <li class="tr" v-for="r in result">
            <router-link :to="r.pid && '/challenge/'+r.pid || ''">
              <span>{{r.title}}</span>
              <span>{{r.score}}</span>
              <span>{{r.solver}}</span>
              <span>{{formatTime(r.timestamp)}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if="ctfMode == 'teams'" class="third">
        <span>{{teamMembers_}}</span>
        <ul class="table">
          <li class="thead">
            <a>
              <span>{{hacker_}}</span>
              <span>{{score_}}</span>
              <span>{{solved_}}</span>
            </a>
          </li>
          <li class="tr" v-for="r in members">
            <a>
              <span>{{r.uid}}</span>
              <span>{{r.rating}}</span>
              <span>{{r.solved}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="right">
      <div class="first" v-if="true">
        <h5>{{topTeams_}}</h5>
        <ul class="table rank">
          <li class="thead">
            <a>
              <span>{{rank_}}</span>
              <span>{{team_}}</span>
            </a>
          </li>
          <li class="tr" v-for="(r, index) in rankInfo">
            <router-link :to="r.tid && '/team/'+r.tid || ''">
              <span>{{index + 1}}</span>
              <span>{{r.name}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { team, rank, top, uploadLogo } from '@/utils/api.js'
  import { getCountryName } from '@/utils/country.js'
  import { natural, formatTime } from '@/utils'
  import i18n from '@/i18n'
  import bus from '@/utils/event_bus.js'

  export default {
    data () {
      return {
        teamName: '',
        logoUrl: '/logo/player_default.png',
        flagTitle: '',
        flagURL: '',
        rank: 0,
        total_teams: 0,
        score: 0,
        size: 0,
        solved: 0,
        total_problems: 0,
        result: [],
        members: [],
        rankInfo: []
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale', 'ctfMode']),
      ...mapGetters([]),
      ...i18n.map([
        'rank_', 'score_', 'teamMembers_', 'location_',
        'teamToken_', 'clickToUpload_', 'solvedChallenges_',
        'solved_', 'total_', 'name_', 'score_', 'solvedBy_',
        'time_', 'teamMembers_', 'hacker_', 'score_', 'solved_',
        'topTeams_', 'rank_', 'team_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      formatTime,
      submit () {
        const fd = new FormData(this.$refs.imgForm)
        uploadLogo(fd)
          .then((data) => {
            this.logoUrl = data.logo
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      init () {
        team(this.$route.params.tid)
          .then((data) => {
            if (data && data.country) {
              this.flagURL = `/flags/${data.country.toLowerCase()}.png`
              this.flagTitle = getCountryName(data.country)
            }
            this.teamName = data.name
            this.logoUrl = data.logo || '/logo/player_default.png'
            this.solved = data.solved.length
            this.score = data.rating
            this.size = data.size || 1
            this.rank = natural(data.rank)
            this.total_teams = natural(data.total_teams)
            this.total_problems = natural(data.total_problems)
            this.profile.token = data.token
            this.permission_upload_logo = data.permission_upload_logo

            this.result = data.solved || []
            this.members = data.members || []

            return data.tid
          })
          .then((tid) => {
            return rank()
              .then((data) => {
                for (let i in data.rank) {
                  if (data.rank[i].tid === tid) {
                    this.rank = natural(i + 1)
                    break
                  }
                }
              })
          })
          .catch((err) => {
            const [error] = err.message.split(': ')
            if (error === 'not_found' || error === 'no_team') return this.$router.push('/profile')

            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
        top().then((data) => {
          this.rankInfo = data.data
        })
      }
    },
    created () {
      this.init()
      bus.$on('UPDATE', this.init)
    },
    beforeDestroy () {
      bus.$off('UPDATE', this.init)
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/team.vue